export const getDay = (date)=>{
    let week_day_name = ""

    switch (date.WeekDay) {
        case 1:
            week_day_name = "Lundi"
            break;
        case 2:
            week_day_name = "Mardi"
            break;
        case 3:
            week_day_name = "Mercredi"
            break;
        case 4:
            week_day_name = "Jeudi"
            break;
        case 5:
            week_day_name = "Vendredi"
            break;
        case 6:
            week_day_name = "Samedi"

            break;
        case 0:
            week_day_name = "Dimanche"  
            break;
    
        default:
            console.log("date is empty")
            break;
    }

    return(week_day_name)

}

export const day = (i) => {
    return {
        Closing: "0000-01-01T00:00:00Z",
        Date: "",
        FromDate: "1970-01-01T00:00:00Z",
        MiddayClosing: "0000-01-01T00:00:00Z",
        MidddayOpening: "0000-01-01T00:00:00Z",
        Opening: "0000-01-01T00:00:00Z",
        ToDate: "2999-12-31T23:59:59Z",
        WeekDay: i
    }
}

export const getDate = (date: string, day: number) => {
    const currentDate = new Date(date);
    const currentDay = currentDate.getDay();
    const change = day === 0 ? 7 - currentDay : day - currentDay;
    currentDate.setDate(currentDate.getDate() + change);
    return currentDate.toLocaleDateString();
};
